





























































































































































import Vue from 'vue';
import BillingProduct from '@/datatypes/billing/product';
import Enterprise from '@/datatypes/enterprise';
import SubscriptionCreateRequest from '@/datatypes/billing/subscription-create-request';
import TaxRate from '@/datatypes/billing/tax-rate';
import User from '@/datatypes/user';
import BillingPriceStructure from '@/components/billing/billing-price-structure.vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import BillingProductService from '@/services/billing/BillingProductService';
import TaxRateService from '@/services/billing/TaxRateService';
import SubscriptionService from '@/services/billing/SubscriptionService';
import BillingPrice from '@/datatypes/billing/price';
import MoneyInput from '@/components/money.vue';

export default Vue.extend({
  props: {
    enterprise: Enterprise,
  },
  components: {
    BillingPriceStructure,
    MoneyInput,
  },
  data: () => ({
    newSubscription: new SubscriptionCreateRequest({}),
    billingProductId: undefined as undefined | string,
    billingPriceId: undefined as undefined | string,
    billingProducts: new Array<BillingProduct>(),
    billingPrices: new Array<BillingPrice>(),
    selectedBillingPrice: new BillingPrice({}),
    billingProductService: new BillingProductService(),
    subscriptionService: new SubscriptionService(),
    taxRateService: new TaxRateService(),
    taxRates: new Array<TaxRate>(),
    user: new User({}),
    isCreatingSubscription: false,
  }),

  mounted() {
    const productListOptions = {
      limit: 100,
    };

    this.billingProductService.list(productListOptions).then((response) => {
      this.billingProducts = response.data.map(
        (data) => new BillingProduct(camelcaseKeysDeep(data)),
      );
    });
    this.taxRateService.list({}).then((response) => {
      this.taxRates = response.data.map(
        (data) => new TaxRate(camelcaseKeysDeep(data)),
      );
    });
  },

  watch: {
    billingProductId(value) {
      if (value) {
        this.billingPriceId = undefined;
        this.selectedBillingPrice = new BillingPrice({});
        this.loadBillingPrices();
      }
    },
  },

  methods: {
    loadBillingPrices() {
      if (!this.billingProductId) return;
      const options = {
        subscriptionScheme: 'v2',
      };

      this.billingProductService.listPrices(this.billingProductId, options).then((response) => {
        this.billingPrices = response.data.map((data) => new BillingPrice(camelcaseKeysDeep(data)));
      });
    },

    loadTaxRates() {
      if (!this.billingPriceId) return;

      this.taxRateService.list(this.billingProductId).then((response) => {
        this.billingPrices = response.data.map((data) => new BillingPrice(camelcaseKeysDeep(data)));
      });
    },

    setBillingPrice(price) {
      const billingPrice = this.billingPrices.find((internalPrice) => internalPrice.id === price);

      if (billingPrice) {
        this.selectedBillingPrice = billingPrice;
        this.newSubscription.billingPriceId = billingPrice.id;
        this.newSubscription.kind = billingPrice.metadata.kind as number;
        this.newSubscription.quota = billingPrice.metadata.quota;
        this.newSubscription.quotaRenewal = billingPrice.metadata.quotaRenewal as 'month' | 'year';
        this.newSubscription.smsUnitAmount = billingPrice.metadata.smsUnitAmount as number;
        this.newSubscription.overageUnitAmount = billingPrice.metadata.overageUnitAmount;
      }

      this.billingPriceId = price;
    },

    setTaxRate(rate) {
      this.newSubscription.taxRateId = rate;
    },

    smsUnitAmountChange(value) {
      this.newSubscription.smsUnitAmount = value;
    },

    overageUnitAmountChange(value) {
      this.newSubscription.overageUnitAmount = value;
    },

    createSubscription() {
      this.subscriptionService.create(this.enterprise.id, this.newSubscription).then(() => {
        this.$snackbar.message('Subscription created.');
        this.$router.push(`/businesses/${this.enterprise.id}`);
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },

    cancelSubscriptionCreation() {
      this.$emit('cancelSubscription');
    },
  },
  computed: {
    kinds(): Array<Array<string|number>> {
      return this.user.kindHash.filter(
        (item) => item.subscription === true,
      ).map(
        (item) => [item.kind, item.name],
      );
    },
    payg(): boolean {
      return this.selectedBillingPrice.payg();
    },
  },
});
